export function toggleDropdown(selector, openedClassName, useParent) {
    $(selector).on("click", function () {
        useParent ? $(this).parent().toggleClass(openedClassName) : $(this).toggleClass(openedClassName);
    });
}

toggleDropdown("[data-dropdown]", "opened", true);
